// 알림 유틸리티 - 카카오 알림톡 + 브라우저 푸시 알림

// ─── 브라우저 푸시 알림 (즉시 사용 가능) ───
export function requestNotificationPermission() {
  if ('Notification' in window) {
    Notification.requestPermission();
  }
}

export function sendBrowserNotification(title, body, onClick) {
  if ('Notification' in window && Notification.permission === 'granted') {
    const n = new Notification(title, {
      body,
      icon: '/favicon.ico',
      badge: '/favicon.ico',
    });
    if (onClick) n.onclick = onClick;
  }
}

// ─── 카카오 알림톡 (카카오 비즈니스 계정 필요) ───
// 1. https://business.kakao.com 에서 비즈니스 채널 생성
// 2. 알림톡 채널 등록 및 템플릿 승인
// 3. 아래 값을 실제 발급받은 값으로 교체
const KAKAO_CONFIG = {
  apiKey: 'YOUR_KAKAO_REST_API_KEY',       // 카카오 REST API 키
  channelId: 'YOUR_KAKAO_CHANNEL_ID',      // 채널 ID
  templateId: 'YOUR_TEMPLATE_ID',          // 승인된 템플릿 ID
};

// 카카오 알림톡 발송 (백엔드 경유 필요 - CORS 때문)
export async function sendKakaoNotification({ to, approverName, docTitle, requesterName, actionUrl }) {
  // 백엔드 API를 통해 발송 (직접 호출 시 CORS 오류 발생)
  try {
    const res = await fetch('/api/notify/kakao', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        to,           // 수신자 전화번호 (010-0000-0000)
        templateId: KAKAO_CONFIG.templateId,
        variables: {
          '#{결재자명}': approverName,
          '#{문서명}': docTitle,
          '#{기안자명}': requesterName,
          '#{링크}': actionUrl,
        },
      }),
    });
    return await res.json();
  } catch (e) {
    console.warn('카카오 알림 발송 실패:', e);
  }
}

// 결재 요청 시 통합 알림 발송
export function notifyApprovalRequest({ approverName, docTitle, requesterName }) {
  // 브라우저 알림 (즉시 동작)
  sendBrowserNotification(
    `📋 결재 요청: ${docTitle}`,
    `${requesterName}님이 결재를 요청했습니다.`,
  );
  // 카카오 알림톡은 백엔드 연동 후 활성화
  // sendKakaoNotification({ ... });
}

// 결재 완료 시 통합 알림 발송
export function notifyApprovalResult({ requesterName, docTitle, status }) {
  const label = status === 'approved' ? '✅ 승인' : '❌ 반려';
  sendBrowserNotification(
    `${label}: ${docTitle}`,
    `${requesterName}님의 결재가 ${label}되었습니다.`,
  );
}
